import React from 'react';
import { Video, Layers, SunMedium, Wand2, BarChart3 } from 'lucide-react';

const MODULES = [
  { id: 'video', label: 'Video Studio', icon: Video },
  { id: 'meta-analytics', label: 'Meta Ads & Leads', icon: BarChart3 },
  { id: 'upscaler', label: 'AI Upscaler', icon: Layers },
  { id: 'relight', label: 'Relight Engine', icon: SunMedium },
  { id: 'auto-edit', label: 'Auto-Editor & Captions', icon: Wand2 },
];

export function ModuleTabs({ activeTab, onSelectTab }) {
  return (
    <div style={{
      display: 'flex',
      background: '#12141e',
      padding: '4px',
      borderRadius: '10px',
      border: '1px solid rgba(255,255,255,0.06)'
    }}>
      {MODULES.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onSelectTab(tab.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 14px',
              borderRadius: '7px',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
              border: 'none',
              transition: 'all 0.2s',
              background: isActive
                ? 'linear-gradient(135deg, rgba(168, 85, 247, 0.25), rgba(99, 102, 241, 0.25))'
                : 'transparent',
              color: isActive ? '#f8fafc' : '#94a3b8',
              boxShadow: isActive ? 'inset 0 0 0 1px rgba(168, 85, 247, 0.4)' : 'none'
            }}
          >
            <Icon size={15} color={isActive ? '#c084fc' : '#94a3b8'} />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
